import { createSelector } from '@ngrx/store';
import { CacheKeyStateMap } from '../reducers/cacheKey.reducer';
import { selectGandalfState } from '../reducers/root';

export const selectGandalfCacheKeys = createSelector(selectGandalfState, state => state.cacheKeys);

export const selectGandalfCacheKey = (props: {key: string}) =>
	createSelector(selectGandalfCacheKeys, (state: CacheKeyStateMap) => state.get(props.key));
